
import createIcon from "./createIcon";

export const TypographyIcon = createIcon('Typography', (props) => {
  return (
    <svg {...props}>
      <path d="M8.68 12.05L8.68 4.3L12.44 4.3L12.44 3.02L3.54 3.02L3.54 4.3L7.32 4.3L7.32 12.05L8.68 12.05Z" fill={props.color} fillOpacity="0.749020" fillRule="evenodd" />
    </svg >
  )
});
